import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from './linkedservice';

import { AzureStorageLinkedService } from './azure-storage.linkedservice';
import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference, validateNullLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { shellStringResources, IViolation, Credential, AuthenticationType } from 'shell-models-lib';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'AzureBatch',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureBatch_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureBatch_DisplayText)
    ]
})
export class AzureBatchLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountName
    })
    public accountName: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureBatchAccessKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureBatchBatchUrl
    })
    public batchUri?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureBatchPoolName
    })
    public poolName: string;

    @Metamodel.attribute({
        reference: true,
        type: AzureStorageLinkedService.MODEL,
        constraint: {
            validator: !__IS_FABRIC_DPE__ ? validateNullLinkedserviceReference : undefined
        }
    })
    public azureStorageLinkedService?: AzureStorageLinkedService;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: AzureBatchLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    public authenticationType?: string = AuthenticationType.AccountKey;
    public isAuthRefMethodCredential?: boolean = false;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedservice: AzureBatchLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice &&
            linkedservice.isAuthRefMethodCredential &&
            !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
